import { query, serviceQueries } from '@estee/elc-service-bus';
import { action, observable } from 'mobx';
import { Inventory } from '../domain/entities/Inventory';
import { Sku } from '../domain/entities/Sku';
interface ISkuInventoryMap {
    [key: string]: Inventory;
}

export interface IProdcatInventory {
    legacy?: boolean;
}
export interface IInventoryRepositoryConfig {
    prodcatInventory?: IProdcatInventory;
}

export interface IInventoryQueryResponse {
    skuId: string;
    inventoryStatus: string;
    isUpdatedInventorySource?: boolean;
    highVelocityQuantity?: number;
}
export class InventoryRepository {
    @observable public inventories: ISkuInventoryMap = {};
    private prodcatInventory?: IProdcatInventory;

    public getInventory = (sku: Sku) => {
        if (this.inventories[sku.skuId]) {
            return this.inventories[sku.skuId];
        }
    };

    public setConfigs(inventoryRepositoryConfig: IInventoryRepositoryConfig) {
        this.prodcatInventory = inventoryRepositoryConfig.prodcatInventory;
    }

    private shouldUpdateInventories(productIds: string[]) {
        return this.prodcatInventory && this.prodcatInventory.legacy && productIds.length > 0;
    }

    @action
    public updateInventories = async (productIds: string[]) => {

        if (this.shouldUpdateInventories(productIds)) {
            try {
                const skusUpdated: IInventoryQueryResponse[] = await query(
                    serviceQueries.GET_INVENTORY,
                    productIds
                );

                this.inventories = skusUpdated
                    .map((skuInventory) => Inventory.fromJson(skuInventory))
                    .reduce((inventories, skuInventory: Inventory) => {
                        inventories[skuInventory.skuId] = skuInventory;

                        return inventories;
                    }, this.inventories);
            } catch (err) {
                console.warn(new Error(err));
            }
        }
    };
}
